import { Button } from "@/components/elements/Button";
import { InnerBox } from "@/components/elements/InnerBox";
import { SettingInfoItem } from "@/features/user-setting/components/setting-info/SettingInfoItem";
import { TGetUserSettingOutputDto } from "@/features/user-setting/dtos/get-user-setting.dto";
import { AppRoutes } from "@/routes/config";
import { black, divider } from "@/theme/colors";
import { Divider, Grid, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";

type TAccountInfoProps = {
  user: TGetUserSettingOutputDto;
};

export const AccountInfo: FC<TAccountInfoProps> = ({ user }) => {
  return (
    <InnerBox padding={3} showDivider={false} borderColor={divider.high}>
      <Stack alignItems="flex-start">
        <Typography variant="head20Bold" color={black[30]}>
          アカウント情報
        </Typography>

        <Grid mt={2} container>
          <Grid item xs={4}>
            <SettingInfoItem label="氏名" value={user.userFullName} />
          </Grid>
          <Grid item xs={8} />
        </Grid>
        <Grid container spacing={2} columnGap={2}>
          <Grid item xs={12} sm={4}>
            <Typography variant="cap12" color={black[70]} mb={1}>
              メールアドレス
            </Typography>
            <Stack spacing={0.5} mt={1}>
              <Typography variant="body14" color={black[30]}>
                {user.userEmail}
              </Typography>
              {user.userNewEmail && (
                <Typography variant="body14" color={black[30]}>
                  {`${user.userNewEmail} (確認中)`}
                </Typography>
              )}
            </Stack>

            <Divider sx={{ mt: 2 }} />
          </Grid>
          <Grid item xs={12} sm={6} display="flex" alignItems="center">
            <Button component={Link} size="sm" variant="outline" to={AppRoutes.userSettingChangeEmail} sx={{ minWidth: "160px" }}>
              メールアドレス変更
            </Button>
          </Grid>
          <Grid item xs={4}>
            <SettingInfoItem label="部署" value={user.userDepartment ?? ""} isShowDivider={false} />
          </Grid>
          <Grid item xs={4}>
            <SettingInfoItem label="役職" value={user.userPosition} isShowDivider={false} />
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
